export interface CartQuantityItem {
  productId: number;
  quantity: number;
  quantity_type?: string; //type
  amount?: string;
  quantityTypeId?: number;
}